$(document)
  .off(
    "click.faqAccordion",
    ".question_product, .faq_product, .faq_question, .custom_icons_faq_main .icons_with_text_item_title"
  )
  .on(
    "click.faqAccordion",
    ".question_product, .faq_question, .custom_icons_faq_main .icons_with_text_item_title",
    function (e) {

      e.preventDefault();
      e.stopImmediatePropagation();

      var $this = $(this);
      var $content = $this.next();

      // stop running animations
      $(".question_product, .faq_question, .custom_icons_faq_main .icons_with_text_item_title")
        .next()
        .stop(true, true);

      // close if already open
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $content.slideUp();
        return;
      }

      // close all
      $(".question_product, .faq_question, .custom_icons_faq_main .icons_with_text_item_title")
        .removeClass("active")
        .next()
        .slideUp();

      // open current
      $this.addClass("active");
      $content.slideDown();
    }
  );

  

$(document).on("click", ".faq_question_new_main", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.faq_question_new_main').removeClass('active');
    jQuery('.faq_question_text').removeClass('active');
    jQuery('.faq_question_new_main').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});




 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });








$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('start_count');
  $block.find('.count_js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.custom_counter .icons_with_text_flex').each(function () {
    const $block = $(this);
    if ($block.hasClass('start_count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);




$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.product_slider_custom_slider_button a.custom_hk_button, .ajax_add_cart ', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
    $.get(window.location.pathname, function (res) {
      var $new = $(res).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($new);
         // Update cart count
      const $newCartCount = $(res).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      
      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
      } else {
        $('.cart_count_js').text('').hide();
      }
      $('#cart-drawer').removeClass('is_empty').addClass('open');
      $('.custom_overlay2').addClass('active');
      this_element.removeClass('loading_hk');
    });
 } 
 });
  });



   $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.pdp_result_list2 .icons_with_text_flex .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});



$(document).on("click", 'a[href="#ingredients"]', function (e) {
 e.preventDefault(); 
$('.pdp_works_popup').css('display','flex').addClass('active');
});



$(document).on("click", '.works_popup_text1 .icons_with_text_item .icons_with_text_item_svg', function (e) {
 e.preventDefault(); 
$('.pdp_works_popup').hide().removeClass('active');
});

// CLOSE POPUP ON OUTSIDE CLICK
$(document).on('click', '.pdp_works_popup', function(e) {

  // If click is INSIDE .custom_popup OR .icon_with_text_flex → DO NOTHING
  if (
    $(e.target).closest('.pdp_works_popup .container_hk .richtext_blocks_new').length > 0
  ) {
    return;
  }

  // Otherwise → close popup
  $('.works_popup_text1 .icons_with_text_item .icons_with_text_item_svg').trigger('click');
});





$(document).on("click", 'a[href="#show"]', function (e) {
  e.preventDefault();
  $('.show_js').hide();
  $('.hide_js').show();
  $('.pdp_review3_section .review_slider_main_slider_new .review_slider_custom_slider_new_item:nth-child(3)~*').show();
});

$(document).on("click", 'a[href="#hide"]', function (e) {
  e.preventDefault();
  $('.show_js').show();
  $('.hide_js').hide();
  $('.pdp_review3_section .review_slider_main_slider_new .review_slider_custom_slider_new_item:nth-child(3)~*').hide();
}); 



$(document).ready(function () {
  $('.pdt_faq_2 ul').slick({
    arrows: false,
    dots: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: false,
    centerPadding: '0px',
    infinite: true,
    adaptiveHeight: true,
    cssEase: 'linear',
  });
});


$(document).on("click", ".pdt_faq_2 .question_product", function () {
    $('.pdt_faq_2 ul').slick('refresh');
  setTimeout(() => {
    $('.pdt_faq_2 ul').slick('refresh');
  }, 50);
});


document.querySelector(".pdt_faq_2").addEventListener("click", function(){
  setTimeout(() => {
     $(".pdt_faq_2 .slick-slider").slick('unslick')

    $('.pdt_faq_2 ul').slick({
    arrows: false,
    dots: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: false,
    centerPadding: '0px',
    infinite: true,
    adaptiveHeight: true,
    cssEase: 'linear',
  });
  }, 200);
  })



